export default "__VITE_ASSET__uen38Acz__"